import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UsuarioEsquema} from '../../usuarioEsquema';
import {Usuario} from '../../usuario';
import {ConfInicialesService} from '../../servicios/conf-iniciales.service';
import {Contrndistribpcc} from '../coninterfaces/contrndistribpcc';
import {Observable} from 'rxjs';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ContrndistribpccService {
  
  get detDistribcc(): Contrndistribpcc[] {
    return this._detDistribcc;
  }
  
  set detDistribcc(value: Contrndistribpcc[]) {
    this._detDistribcc = value;
  }

  
  private way: string;
  public hmpConfiguracion: any[];
  public dblValor: string;
  public totalDist = Number(0).toFixed(2);
  
  private _detDistribcc: Contrndistribpcc[];
  
  constructor(private http: HttpClient,
              public usuarioEsquema: UsuarioEsquema,
              public usuario: Usuario, private confIniciales: ConfInicialesService) {
    this.way = sessionStorage.getItem('way');
  }
  
  refrescarURL() {
    if (this.way === null) {
      this.way = sessionStorage.getItem('way');
    }
  }
  
  listarDatos(strAsiNro, intDetasiNroFila): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/cont/distribucionpcc/565ceab6d5771c', {
        elementos: {
          p_asi_nro: strAsiNro,
          p_detasi_nrofila: intDetasiNroFila,
          p_com_codigo: '01',
        },
      }, this.confIniciales.httpOptions()
    );
  }

  erContipgas(strCodigo) {  
    return this.http.post(this.way + '/cont/distribucionpcc/3b6cc5fb2cc15c', {
      elementos: {
        CON_CODIGO: strCodigo
      },
    }, this.confIniciales.httpOptions());
  }

  erTipgascodigo() {  
    return this.http.post(this.way + '/cont/distribucionpcc/1dbecb305719870000', {
      elementos: {},
    }, this.confIniciales.httpOptions());
  }
  
  
  getConfiguraciones(codigo): number {
    const valorConfig = this.hmpConfiguracion.find(element => element.CFG_CODIGO === codigo).CFG_VALOR1;
    return valorConfig;
  }
  calcularTotal() {
    
    let intIndiceLista = 0;
    let item: Contrndistribpcc;
    let dblTotal = 0;
    
    
    for (intIndiceLista = 0; intIndiceLista < this.detDistribcc.length; intIndiceLista++) {
      item = this.detDistribcc[intIndiceLista];
      
      dblTotal = dblTotal + Number(item.TRNDISP_VALOR);
    }
    
    this.totalDist = Number(dblTotal).toFixed(this.confIniciales.getNumDecSist());
    
  }
  
  guardarDistribucion(item: Contrndistribpcc): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/cont/distribucionpcc/e2bee6cb9ddc980', {
        elementos: {
          p_asi_nro: item.ASI_NRO,
          p_detasi_nrofila: Number(item.DETASI_NROFILA),
          p_com_codigo: '01',
          p_cen_codigo: item.CEN_CODIGO,
          p_trndisp_valor: Number(item.TRNDISP_VALOR),
          p_trndisp_porce: Number(item.TRNDISP_PORCE),
          p_con_codigo: item.CON_CODIGO,
          p_trndisp_linea: Number(item.TRNDISP_LINEA),
          p_prog_codigo: item.PROG_CODIGO,
          p_tipgas_codigo: item.TIPGAS_CODIGO,
          p_ENCPARPRE_ANIO: item.ENCPARPRE_ANIO,
          p_DETPARPRE_NUMERO: item.DETPARPRE_NUMERO,
          
        },
      
      }, this.confIniciales.httpOptions()
    );
  }
  
  eliminarLineaSel(item: Contrndistribpcc): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/cont/distribucionpcc/75656acaee571c0', {
        elementos: {
          p_asi_nro: item.ASI_NRO,
          p_detasi_nrofila: Number(item.DETASI_NROFILA),
          p_com_codigo: '01',
          p_trndisp_linea: Number(item.TRNDISP_LINEA)
        },
        
      }, this.confIniciales.httpOptions()
    );
  }
  
  listarDatosAutomatica(StrAsiNro, intDetasiNroFila, strTrnProCenCodigo): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/cont/distribucionpcc/acb9d6abb857b80', {
        elementos: {
          p_trnprocen_codigo: strTrnProCenCodigo,
          p_com_codigo: '01',
          p_asi_nro: StrAsiNro,
          p_detasi_nrofila: intDetasiNroFila,
        },
      }, this.confIniciales.httpOptions()
    );
  }
  validasaldetparprenum(numero, anio,mes) {
    return this.http.post<any[]>(this.way + '/compras/factproveedores/7d559354d7772c0000000000', {
      elementos: {
        p_anio: anio,
        p_numero: numero,
        p_mes:mes+1,
        p_com_codigo:'01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validadetparprenum(arreglo,anio): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/compras/factproveedores/3eaac9aabfacd8000000000', {
      elementos: {
        arreglo,
        p_anio:anio
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  parseToIntAndScale(n) {
    const s = String(n);
    if (s.indexOf('e') !== -1) {
      return this.parseToIntAndScale(Number(s).toFixed(18).replace(/0+$/, ''));
    }
    const parts = s.split('.');
    const scale = parts[1] ? parts[1].length : 0
    const intVal = Number(parts.join(''));
    return { intVal, scale }
  }
  toCents(n) {
    if (isNullOrUndefined(n) || n === '') {
      return 0
    }
    const p = this.parseToIntAndScale(n);
    if (p.scale === 2) {
      return p.intVal
    }
    if (p.scale < 2) {
      return p.intVal * Math.pow(10, 2 - p.scale)
    } else {
      const factor = Math.pow(10, p.scale - 2)
      return Math.round(p.intVal / factor)
    }
  }
  
  agruparYsumar(datos){
    const acc = new Map<string,{DETPARPRE_NUMERO:string;cents:number}>()
    for (const item of datos) {
      const key = item.DETPARPRE_NUMERO;
      if (isNullOrUndefined(key) || String(key).trim() === '') continue;

      const cents = this.toCents(item.TRNDISP_VALOR);
      if (!acc[key]) {
        acc[key]={DETPARPRE_NUMERO:key,cents:0}
      }
      acc[key].cents+=cents
    }
    return Object.values(acc).map(o=>({
      DETPARPRE_NUMERO:o.DETPARPRE_NUMERO,
      TRNDISP_VALOR:parseFloat((o.cents / 100).toFixed(2))
    }))
  }
}
